<template>
  <AppAdSense
    v-if="!subscriptionStore.isPaidUser"
    ad-class="adsense adsense--multiplex"
    ad-style="display:block"
    ad-format="autorelaxed"
    ad-client="ca-pub-9118328092882671"
    ad-slot="2637435883"
  />
</template>

<script setup lang="ts">
  import { useSubscriptionStore } from '$/stores/subscription'

  const subscriptionStore = useSubscriptionStore()
</script>

<style lang="sass" scoped>
  .adsense--multiplex
    min-height: 300px
    text-align: center
    margin: auto
</style>
